// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.remote-share-dialog__password[data-v-3dcfb154]{margin-block:1em .5em}`, "",{"version":3,"sources":["webpack://./apps/federatedfilesharing/src/components/RemoteShareDialog.vue"],"names":[],"mappings":"AAGC,gDACC,qBAAA","sourcesContent":["\n.remote-share-dialog {\n\n\t&__password {\n\t\tmargin-block: 1em .5em;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
